import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { TransferState } from '@angular/core';

import { TranslateBrowserLoader } from './translate-loader.browser';

export function UniversalTranslateLoader(
  http: HttpClient, 
  transferState: TransferState,
  platformId: Object
) {
  if (isPlatformBrowser(platformId)) {
    return new TranslateBrowserLoader(http, transferState);
  } else {
    const { TranslateServerLoader } = require('./translate-loader.server');

    return new TranslateServerLoader(transferState);
  }
}
